import React from 'react';
import ACTIONS from '~shared/actions';
import { PackageIds, Packages } from '~shared/constants/pricing';
import { CombinedActions } from '~shared/types/pricing/actions';
import IncludedLink from './components/Categories/IncludedLink';
import { TEAMS_PACKAGES } from '../../lib/constants';

export function determinePackageSwap(
  numberOfUsers: string,
  isAdvantagePackage: boolean,
  isPremierPackage: boolean,
  dispatch: React.Dispatch<CombinedActions>,
  packageName?: Packages
): void {
  let packageSwap = {};

  if (isAdvantagePackage) {
    if (Number(numberOfUsers) > 1) {
      packageSwap = {
        packageToBeReplaced:
          packageName && packageName === Packages.AdvantageMonthly
            ? PackageIds.ADVANTAGE_MONTHLY
            : PackageIds.ADVANTAGE_ANNUAL,
        replacedWith: PackageIds.TEAM_ADVANTAGE_ANNUAL,
      };
    } else {
      packageSwap = {
        packageToBeReplaced: PackageIds.TEAM_ADVANTAGE_ANNUAL,
        replacedWith: PackageIds.ADVANTAGE_ANNUAL,
      };
    }
    dispatch({ type: ACTIONS.SWITCH_PACKAGES, payload: packageSwap } as CombinedActions);
  }

  if (isPremierPackage) {
    if (Number(numberOfUsers) > 1) {
      packageSwap = {
        packageToBeReplaced: PackageIds.PREMIER_ANNUAL,
        replacedWith: PackageIds.TEAM_PREMIER_ANNUAL,
      };
    } else {
      packageSwap = {
        packageToBeReplaced: PackageIds.TEAM_PREMIER_ANNUAL,
        replacedWith: PackageIds.PREMIER_ANNUAL,
      };
    }
    dispatch({ type: ACTIONS.SWITCH_PACKAGES, payload: packageSwap } as CombinedActions);
  }
}

export function switchAndSave(
  numberOfUsers: string,
  isAdvantagePackage: boolean,
  isPremierPackage: boolean,
  dispatch: React.Dispatch<CombinedActions>,
  packageName?: Packages
): void {
  determinePackageSwap(numberOfUsers, isAdvantagePackage, isPremierPackage, dispatch, packageName);

  dispatch({
    type: ACTIONS.PNP_REFRESH_CHANGE_USERS,
    payload: { users: numberOfUsers, packageType: isAdvantagePackage ? 'advantageUsers' : 'premierUsers' },
  } as CombinedActions);
}

export function getTeamCollaborationValues(packageName: Packages): boolean | React.ReactElement {
  let value: boolean | React.ReactElement = false;
  if (TEAMS_PACKAGES.includes(packageName)) {
    value = true;
  }

  if ([Packages.AdvantageAnnual, Packages.AdvantageMonthly, Packages.PremierAnnual].includes(packageName)) {
    value = <IncludedLink packageName={packageName} />;
  }

  return value;
}
